// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".log-com .el-tabs__item {\n  color: #606266;\n}\n.log-com .el-tabs__content {\n  background-color: #FAFAFA;\n}\n.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {\n  background-color: #1890FF !important;\n  border-radius: 3px 3px 0px 0px !important;\n  color: #FFFFFF !important;\n}", ""]);
// Exports
module.exports = exports;
